import { defineStore } from 'pinia';
import { normalizeOpenIntent } from '@/utils/openIntent';

export const useOpenIntentStore = defineStore('openIntentStore', {
  state: () => ({
    intent: null,
  }),
  getters: {
    contextType(state) {
      return state.intent?.source || 'course';
    },
    historyContextLabel(state) {
      const mode = state.intent?.historyOpenMode;
      if (mode === 'view') return 'История: просмотр';
      if (mode === 'fork') return 'История: копия';
      if (mode === 'edit') return 'История: редактирование';
      return 'Курс';
    },
  },
  actions: {
    setIntent(rawIntent) {
      this.intent = normalizeOpenIntent(rawIntent);
    },
    clearIntent() {
      this.intent = null;
    },
  },
});
